module.exports = __webpack_public_path__ + "static/media/icon-loading-coral.5d378cef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-loading-coral.svg
// module id = 406
// module chunks = 0